export const blockIconsSocialGroupAdd = (
	<span className='material-symbols-outlined'>group_add</span>
);
